
$j("section[class^='feature-'] a").click(function (e) {
    e.preventDefault();
});
$j("section[class^='feature-']").on("click", function (e) {
    var hrefLink = $j(this).find("a").attr('href');
    var url = "";
    if (hrefLink === "" || hrefLink == null || hrefLink === 'undefined') {
        url = $j(this).data("link-url");
    } else {
        url = hrefLink;
    }
    var target = $j(this).data("link-target");
    if (url.length > 0) {
        window.open(url, target);
    }
});